import { useSelector } from 'react-redux';
import { createSelector } from 'reselect';
import { RootState } from 'store/configureStore';
import { State as CaseState } from 'modules/cm/store/cases/types';
import { useMemo } from 'react';

const getCasePermission = (state: RootState) => {
  const currentCase = state.currentCase as NonNullable<CaseState>;
  return currentCase.permission;
};

const makeSelectIsCaseReadOnly = () => {
  return createSelector([getCasePermission, (state) => state], (permission) => permission.isReadonly);
};

const useCaseIsReadOnly = (): boolean => {
  const isReadonlyMemo = useMemo(makeSelectIsCaseReadOnly, []);
  const isReadonly = useSelector(isReadonlyMemo);
  return isReadonly;
};

export default useCaseIsReadOnly;
